import React from 'react';
import classnames from 'classnames';

import { LinkComponentFragment } from '../../../graphql.schema';
import StrapiLinkUnstyled from '../StrapiLink/StrapiLinkUnstyled';

type NavigationLinkProps = {
  link: LinkComponentFragment;
  className?: string;
};

export const NavigationLink: React.FC<NavigationLinkProps> = ({ link, className }) => {
  const { title, ...linkProps } = link;
  return (
    <StrapiLinkUnstyled className={classnames(className, 'navbar-item is-text-2')} {...linkProps}>
      {title}
    </StrapiLinkUnstyled>
  );
};
